import React, { useState } from 'react';
import { FaTruck, FaTruckPickup, FaShuttleVan } from 'react-icons/fa';
import { GiTruck } from 'react-icons/gi';
import { MdLocalShipping } from 'react-icons/md';

const vehicleData = [
  { type: 'VAN', capacity: 1000, maxDistance: 500, maxPackages: 50, icon: <FaShuttleVan /> },
  { type: 'TRUCK', capacity: 5000, maxDistance: 1000, maxPackages: 200, icon: <FaTruck /> },
  { type: 'SEMI-TRAILER', capacity: 25000, maxDistance: 3000, maxPackages: 1500, icon: <GiTruck /> },
  { type: 'MINI-VAN', capacity: 500, maxDistance: 300, maxPackages: 30, icon: <FaShuttleVan /> },
  { type: 'PICKUP', capacity: 2000, maxDistance: 800, maxPackages: 100, icon: <FaTruckPickup /> },
  { type: 'LARGE TRUCK', capacity: 15000, maxDistance: 2000, maxPackages: 1000, icon: <MdLocalShipping /> }
];

const VehicleSuggestion = () => {
  const [totalDistance, setTotalDistance] = useState('');
  const [totalPackages, setTotalPackages] = useState('');
  const [suggestedVehicles, setSuggestedVehicles] = useState([]);

  const handleDistanceChange = (e) => {
    setTotalDistance(e.target.value);
  };

  const handlePackagesChange = (e) => {
    setTotalPackages(e.target.value);
  };

  const suggestVehicles = () => {
    const distance = parseFloat(totalDistance);
    const packages = parseInt(totalPackages, 10);
    const suggestions = vehicleData.filter(vehicle => 
      vehicle.maxDistance >= distance && vehicle.maxPackages >= packages
    );

    setSuggestedVehicles(suggestions);
  };

  return (
    <div className="flex w-full justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-6xl p-8 bg-white-whiter rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">Sugestão de Veículo</h1>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-700">Dados da Carga</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <input
                type="number"
                value={totalDistance}
                onChange={handleDistanceChange}
                placeholder="Distância Total (km)"
                className="p-4 border rounded-md w-full focus:outline-none focus:border-salBlue"
              />
            </div>
            <div>
              <input
                type="number"
                value={totalPackages}
                onChange={handlePackagesChange}
                placeholder="Quantidade de Pacotes"
                className="p-4 border rounded-md w-full focus:outline-none focus:border-salBlue"
              />
            </div>
          </div>
        </div>

        <button
          onClick={suggestVehicles}
          className="bg-salBlue text-white-whiter p-4 rounded-md w-full hover:bg-blue-700 transition duration-200 mb-8"
        >
          Sugerir Veículos
        </button>

        {suggestedVehicles.length > 0 ? (
          <div>
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">Veículos Sugeridos</h2>
            <table className="min-w-full bg-white-whiter">
              <thead>
                <tr>
                  <th className="py-3 px-6 border-b">Tipo de Veículo</th>
                  <th className="py-3 px-6 border-b">Capacidade (kg)</th>
                  <th className="py-3 px-6 border-b">Distância Máxima (km)</th>
                  <th className="py-3 px-6 border-b">Pacotes Máximos</th>
                </tr>
              </thead>
              <tbody>
                {suggestedVehicles.map((vehicle, index) => (
                  <tr key={index} className="hover:bg-gray-100 transition duration-200">
                    <td className="border px-6 py-3 flex items-center gap-2">
                      {vehicle.icon}
                      {vehicle.type}
                    </td>
                    <td className="border px-6 py-3">{vehicle.capacity}</td>
                    <td className="border px-6 py-3">{vehicle.maxDistance}</td>
                    <td className="border px-6 py-3">{vehicle.maxPackages}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center text-red-500">Nenhum veículo disponível para os dados fornecidos.</p>
        )}
      </div>
    </div>
  );
};

export default VehicleSuggestion;
